import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const CloudRestroUsers = {
  getrestrousers: async () => {
    console.log("API Called");
    try {
      const response = await instance.get("/cloudrestrousers/list");
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateExpirydate: async (payload) => {
    try {
      console.log("success");
      const response = await instance.post(
        "/cloudrestrousers/update-expiry",
        payload,
      );
      console.log(response);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  getbyOrgCode: async (orgCode) => {
    try {
      const response = await instance.get(`/cloudrestrousers/${orgCode}`);
      console.log(response);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  // Get devices with cloud restro users
  getWithDevices: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.name) queryParams.append("name", filters.name);
      if (filters.orgCode) queryParams.append("orgCode", filters.orgCode);
      if (filters.location) queryParams.append("location", filters.location);
      if (filters.macId) queryParams.append("macId", filters.macId);
      if (filters.searchText)
        queryParams.append("searchText", filters.searchText);
      if (filters.onlyWithDevices)
        queryParams.append("onlyWithDevices", filters.onlyWithDevices);

      const queryString = queryParams.toString();
      const url = queryString
        ? `/cloudrestrousers/with-devices?${queryString}`
        : "/cloudrestrousers/with-devices";

      const response = await instance.get(url);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching devices with users:", error);
      throw error;
    }
  },

  // Register new device
  registerDevice: async (deviceData) => {
    try {
      const response = await instance.post(
        "/cloudrestrousers/device-reg",
        deviceData,
      );
      return response.data;
    } catch (error) {
      console.error("Error registering device:", error);
      throw error;
    }
  },

  // Update log duration
  updateLogDuration: async (macId, logDurationInMinutes) => {
    try {
      const payload = {
        macId: macId,
        logDurationInMinutes: parseInt(logDurationInMinutes),
      };
      const response = await instance.put(
        "/cloudrestrousers/update-log-duration",
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating log duration:", error);
      throw error;
    }
  },

  updateHeartbeatWindow: async (macId, showHeartBeatWindow) => {
    try {
      const payload = {
        macId: macId,
        showHeartBeatWindow: showHeartBeatWindow,
      };

      const response = await instance.put(
        "/cloudrestrousers/update-heartbeat-window",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Error updating heartbeat window:", error);
      throw error;
    }
  },

  // Get device organizations by macId
  getDeviceOrganizations: async (macId) => {
    try {
      const response = await instance.get(
        `/cloudrestrousers/device-organizations/${macId}`,
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching device organizations:", error);
      throw error;
    }
  },

  // Bulk insert organizations to device
  bulkInsertOrg: async (payload) => {
    try {
      const response = await instance.post(
        "/cloudrestrousers/bulk-insert-org",
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error bulk inserting organizations:", error);
      throw error;
    }
  },

  // Bulk delete organizations
  bulkDelete: async (ids) => {
    try {
      const payload = { ids: ids };
      const response = await instance.delete("/cloudrestrousers/bulk-delete", {
        data: payload,
      });
      return response.data;
    } catch (error) {
      console.error("Error bulk deleting:", error);
      throw error;
    }
  },

  // Get all devices list
  getDevicesList: async () => {
    try {
      const response = await instance.get("/cloudrestrousers/devices-list");
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching devices list:", error);
      throw error;
    }
  },
};

export default CloudRestroUsers;
